import React from 'react';
import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseLeadPage,
  CarleadStepCompoundBuyCarConsentCustomerPopupGoogleRatings,
  CarleadTopBlueCarGoogleReviewsMap,
  DEFAULT_SLIDER_SETTINGS,
} from '@wkda/marketing-components';
import { SLIDER_SETTINGS } from "../../../default/slider";

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadStepCompoundBuyCarConsentCustomerPopupGoogleRatings}
      content={CarleadTopBlueCarGoogleReviewsMap}
      happyCustomerSettingsOverrides={DEFAULT_SLIDER_SETTINGS}
      className='mobile-blue-bg'
      howItWorksShowCta={true}
      showCounterHeadline={false}
      showTrustPilot={false}
    />
  );
}
CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
